import { useWindowDimensions } from "react-native";

export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;

/**
 * Hook to check if the viewport is large (tablet or desktop)
 */
export function useIsLargeViewport(): boolean {
  const { width } = useWindowDimensions();
  return width >= TABLET_BREAKPOINT;
}

/**
 * Get error message from an error object or return a default message
 */
export function getErrorMessage(
  error?: Error | null,
  defaultMessage: string = "Something went wrong. Please try again.",
): string {
  return error?.message || defaultMessage;
}
